<template>
  <v-card>
    <v-card-title
      class="text-center justify-center py-6 px-sm-16 secondary flex-column flex-sm-row justify-sm-space-between"
      style="border-bottom:1px solid white !important;"
    >
      <div class="font-weight-normal white--text pb-5 pb-sm-0" style="font-size:2rem !important">
        Payments
      </div>

      <custom-date-picker
        defaultStartDate="04/10/2017"
        defaultEndDate="04/12/2017"
        :showDateRange="true"
        @startDateChanged="handleStartDateChanged($event)"
        @endDateChanged="handleEndDateChanged($event)"
      ></custom-date-picker>
      <v-spacer></v-spacer>

      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
    </v-card-title>
    <div class="refresh-wrapper">
      <v-btn
        class="mx-2 refresh-button"
        dark
        small
        color="blue-grey lighten-2"
        @click="refreshPayments"
      >
        Refresh <v-icon dark>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-data-table
      fixed-header
      :items-per-page="25"
      :headers="headers"
      :items="payments"
      :search="search"
      no-data-text="Currently no payments to display. . ."
    >
      <template slot="item.debit_acct_code" slot-scope="item">
        <span @click="showPaymentDetail(item.item)">{{ item.item.debit_acct_code }}</span>
      </template>
      <template slot="item.date" slot-scope="item">{{
        $moment(item.item.date).format("YYYY/MM/DD")
      }}</template>
      <template slot="item.amount" slot-scope="item">{{ floatString(item.item.amount) }}</template>
      <template slot="item.action" slot-scope="item">
        <!-- <v-btn
          class="action-button"
          @click="takeAppropriateAction(item.item)"
          small
          :color="btnColor(item.item)"
          >{{ btnText(item.item) }}</v-btn
        > -->
        <v-row>
          <v-col>
            <v-btn
              :class="btnRevokeClass(item.item)"
              @click="takeAppropriateAction(item.item, 'revoke')"
              small
              >{{ btnRevokeText(item.item) }}</v-btn
            >
          </v-col>
          <v-col
            ><v-btn
              :class="btnApproveClass(item.item)"
              @click="takeAppropriateAction(item.item, 'release')"
              small
              >{{ btnApproveText(item.item) }}</v-btn
            ></v-col
          >
        </v-row>
      </template>
    </v-data-table>
    <payment-detail-component
      v-show="curPayment"
      ref="pdc"
      :payment="curPayment"
    ></payment-detail-component>
  </v-card>
</template>

<script>
import PaymentDetailComponent from "@/components/PaymentDetailComponent";
export default {
  mounted() {
    // this.refreshPayments();
    // console.log(this.payments);
  },
  data() {
    return {
      curPayment: null,
      // payments: [],
      search: "",
      headers: [
        {
          text: "Entity",
          align: "start",
          sortable: false,
          value: "debit_acct_code",
        },
        { text: "Beneficiary", value: "beneficiary", sortable: false },
        { text: "Recon Date", value: "reconDate", sortable: false },
        { text: "Currency", value: "curCode", sortable: false },
        { text: "Amount", value: "amount", sortable: false },
        { text: "Status", value: "wtr_status", sortable: false },
        { text: "", value: "action", sortable: false, align: "center" },
      ],
    };
  },
  methods: {
    refreshPayments() {
      this.$root.setBusy("acquirePayments", "Loading payments . . .");
      this.$store
        .dispatch("payments/getPaymentsForClientID", {
          startDate: this.startDate,
          endDate: this.endDate,
        })
        .then((resp) => {
          console.log("UPDATED PAYMENTS LIST:", resp);
          // this.payments = pmtArray;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$root.removeBusy("acquirePayments");
        });
    },
    btnColor(payment) {
      // WE WANT TO SET THE VALUES FOR THE NEXT STATE, NOT THE CURRENT STATE
      switch (payment.wtr_status.toLowerCase()) {
        case "pending":
          return "success";

        case "approved":
          return "error";

        case "released":
          return "warning";

        default:
          return "secondary";
      }
    },
    btnApproveText(payment) {
      switch (payment.wtr_status.toLowerCase()) {
        case "pending":
          return "Release";
        case "released":
          return "Approve";

        default:
          return "Release";
      }
    },
    btnRevokeText(payment) {
      switch (payment.wtr_status.toLowerCase()) {
        case "released":
          return "Revoke Release";
        case "approved":
          return "Revoke Approval";

        default:
          return "Revoke";
      }
    },
    btnApproveClass(payment) {
      let klass = ["action-button", "approve-button"];
      if (["pending", "released"].indexOf(payment.wtr_status.toLowerCase()) < 0) {
        // klass.push("action-unavailable");
      }

      return klass.join(" ");
    },
    btnRevokeClass(payment) {
      let klass = ["action-button", "revoke-button"];
      if (["released", "approved"].indexOf(payment.wtr_status.toLowerCase()) < 0) {
        // klass.push("action-unavailable");
      }

      return klass.join(" ");
    },
    showPaymentDetail(payment) {
      console.log("CLICKED!!!");
      this.curPayment = payment;
      this.$refs.pdc.dialog = true;
    },
    async takeAppropriateAction(payment, action = null) {
      const res = await this.$dialog.confirm({
        text: `Are you sure you wish to change the status of '<strong>${
          payment.debit_acct_code
        }</strong>' transaction in the amount of <strong>${this.floatString(
          payment.amount
        )}</strong> to a status of <strong>${action.toUpperCase()}</strong>`,
        title: "Warning",
      });

      if (res === true) {
        switch (action.toLowerCase()) {
          case "revoke":
            this.actToRevoke(payment);
            break;
          case "release":
            this.actToRelease(payment);
            break;
          case "approved":
            this.actToApprove(payment);
            break;

          default:
            return false;
        }
      }
    },
    actToRelease(payment) {
      payment.wtr_status = "Released";
    },
    actToApprove(payment) {
      payment.wtr_status = "Approved";
    },
    actToRevoke(payment) {
      payment.wtr_status = "Pending";
    },
    handleStartDateChanged(evtDate) {
      this.$store.commit("payments/SET_START_DATE", evtDate);
    },
    handleEndDateChanged(evtDate) {
      this.$store.commit("payments/SET_END_DATE", evtDate);
    },
  },
  computed: {
    payments() {
      return this.$store.getters["payments/payments"];
    },
  },
  components: {
    PaymentDetailComponent,
  },
  watch: {},
};
</script>

<style lang="postcss">
.action-button {
  width: 100%;
  color: white !important;
  font-weight: bold;
  margin-left: 5px !important;
}

.approve-button {
  background-color: #4caf50 !important;
}
.revoke-button {
  background-color: #ff5252 !important;
}

.action-unavailable {
  background-color: grey !important;
  opacity: 0.2;
  pointer-events: none;
}

.v-data-table__mobile-row__cell button {
  width: 20vw;
}

.refresh-wrapper {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
